import { Component, AfterViewInit } from '@angular/core';
declare var jQuery: any;

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements AfterViewInit {

  constructor() { }

  ngAfterViewInit() {
    jQuery(window).on('resize', () => this.adjustHeight());
    this.adjustHeight();
  }

  adjustHeight() {
    // Force container min height to avoid seeing blank footer
    // Use jQuery since CSS height seems to break floating cols
    jQuery('.content-wrapper .container').css('min-height', jQuery(window).height() - 40);
  }

}
